import { render, staticRenderFns } from "./reviewAnalyze.vue?vue&type=template&id=6946bcb2&scoped=true&"
import script from "./reviewAnalyze.vue?vue&type=script&lang=js&"
export * from "./reviewAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./reviewAnalyze.vue?vue&type=style&index=0&id=6946bcb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946bcb2",
  null
  
)

export default component.exports